
import useRightPath from '~/composables/useRightPath';
import usePreventHandlingEmptyLink from '~/composables/usePreventHandlingEmptyLink';
import AzImg from '~/components/Atoms/AzImg.vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';

export default {
  name: 'EquipmentList',
  components: {
    AzImg,
    NuxtLinkCustom,
  },
  props: {
    activeTab: {
      type: String,
    },
    equipment: {
      type: Array,
      default: () => [],
    },
  },
  setup(_props) {
    const { getProductPath } = useRightPath();

    const getEquipmentName = (equipment) => {
      if (equipment.name) {
        return equipment.name;
      }
      const title = equipment?.nonPurchasableEquipment?.fields?.title;

      return title || '';
    };

    const getEquipmentImage = (equipment) => {
      if (equipment.image) {
        return equipment.image;
      }
      const url = equipment.nonPurchasableEquipment?.fields?.image?.fields?.file?.url;

      return url;
    };

    const getLink = (slug) => {
      return slug ? getProductPath({ slug }) : '';
    };

    return {
      getEquipmentName,
      getEquipmentImage,
      getLink,
      usePreventHandlingEmptyLink,
    };
  },
};
